module.exports = __webpack_public_path__ + "media/images/athletes/3398-55a69eb4ef59a87e9387a33e79ff1907.png";